import type { LucideIcon } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';

import { Icon } from './Icon';
import styles from './IconButton.module.css';

type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  icon: LucideIcon;
  /** Required accessible name. */
  label: string;
  variant?: 'ghost' | 'outline' | 'solid' | 'surface';
  size?: number;
};

export function IconButton({
  icon,
  label,
  variant = 'ghost',
  size = 44,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      aria-label={label}
      title={label}
      className={[styles.iconButton, styles[variant], className ?? ''].join(' ')}
      style={{ width: size, height: size }}
    >
      <Icon icon={icon} size={Math.round(size * 0.45)} />
    </button>
  );
}
